import { render } from "./NewsCategory.vue?vue&type=template&id=1c945cd1&scoped=true"
import script from "./NewsCategory.vue?vue&type=script&lang=js"
export * from "./NewsCategory.vue?vue&type=script&lang=js"

import "./NewsCategory.vue?vue&type=style&index=0&id=1c945cd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c945cd1"]])

export default __exports__